import { SortListAscending } from "app/utils/sort.util";
import { Actions } from "./actions";
import {
  ADD_USER_RESPONSE,
  ADMIN_LIST,
  DELETE_USER_RESPONSE,
  PARTNERS_LIST,
  UPDATE_USER_RESPONSE,
  USER_BY_FIELD_LIST,
  USER_BY_ID,
  USER_LIST,
  USER_LIST_BY_PARTNER_ID,
} from "./actionTypes";
import { initialState, UserManagementState } from "./state";

export function UserManagementReducer(
  state = initialState,
  action: Actions,
): UserManagementState {
  switch (action.type) {
    case USER_LIST:
      return Object.assign({}, state, {
        userList: SortListAscending(action.payload, "name"),
      });
    case USER_BY_FIELD_LIST:
      return Object.assign({}, state, {
        userByFieldList: SortListAscending(action.payload, "name"),
      });
    case USER_BY_ID:
      return Object.assign({}, state, {
        userById: action.payload,
      });
    case ADD_USER_RESPONSE:
      return Object.assign({}, state, {
        addUserResponse: action.payload,
      });
    case UPDATE_USER_RESPONSE:
      return Object.assign({}, state, {
        updateUserResponse: action.payload,
      });
    case DELETE_USER_RESPONSE:
      return Object.assign({}, state, {
        deleteUserResponse: action.payload,
      });
    case USER_LIST_BY_PARTNER_ID:
      return Object.assign({}, state, {
        userListByPartnerId: action.payload,
      });
    case PARTNERS_LIST:
      return Object.assign({}, state, {
        partnersList: action.payload,
      });
    case ADMIN_LIST:
      return Object.assign({}, state, {
        adminsList: action.payload,
      });
    default:
      return state;
  }
}
